import { useTranslation } from 'react-i18next';
import SuccessCheckIcon from '../icons/SuccessCheckIcon';
import { useContext, useEffect, useState } from 'react';
import { WelletContext } from '../../context/WelletContext';
import { useLocation, useHistory } from 'react-router-dom';
import CardEventsDetails from '../CardEventsDetails/CardEventsDetails';
import FixedButton from '../Common/FixedButton/FixedButton';
import Button from '../Common/Button/Button';
const PayConfirmConsumer = () => {
  const { t } = useTranslation();
  const [reservation, setReservation] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const welletContext = useContext(WelletContext);
  const history = useHistory();

  const getPaidReservation = async (token) => {
    try {
      const response = await welletContext.apis.tickets.get(
        `/reservation/getpaid?token=${encodeURIComponent(token)}`,
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const getReservationInfo = async () => {
    try {
      const result = await getPaidReservation(token);
      setReservation(result);
    } catch (error) {
      setError(error.response.data.errorCode);
    }
    // setLoading(false);
  };
  const totalPages = reservation?.tickets.length;
  useEffect(() => {
    getReservationInfo();
  }, []);

  return (
    <div className='payment-confirm-container ' style={{ paddingBottom: 'calc(70px + env(safe-area-inset-bottom))' }}>
      <div className='success-content p-2 mt-5'>
        <div className='text-center pb-5 mt-5'>
          <SuccessCheckIcon color={'var(--color-primary)'} size='135px' />
        </div>
        <div className='font-extra-large text-lighter-gray fw-bold pl-3 pb-2'>
          {t('paymentConfirm.purchaseConfirmed')}
        </div>
        <div className='text-secondary  pl-3'>{t('paymentConfirm.paymentSuccessText')}</div>
        <div className=' text-secondary pl-3'>{t('paymentConfirm.paymentSuccessTextTwo')}</div>
      </div>
      <div className='card p-2 m-3' style={{ marginTop: '10px' }}>
        <div style={{ fontSize: '16px', fontWeight: '500', color: '#fff' }}>
          {t('yourEtickets')}
        </div>
        <div
        className='mt-3 mb-3'
          style={{ borderTop: '1px solid #7e7e7e'}}
        ></div>

        {reservation?.tickets.map((event, index) => (
          <CardEventsDetails
            key={event.id}
            eventSubName={event.showName}
            bannerImage={event.image}
            eventName={event.eventName}
            startDate={event.startDate}
            reservationType={'UNDEFINED'}
            onClick={() => {
              history.push(
                `/ticket-details-success?token=${encodeURIComponent(
                  token,
                )}&indexTicket=${index}&totalTickets=${totalPages}`,
              );
            }}
          />
        ))}
      </div>
      <FixedButton backgroundColor={'#000'}>
        <Button
          text={t('returnHome')}
          size='large'
          className={`mt-2`}
          onClick={() => history.push('/')}
          icon={true}
          typeIcon='arrow'
          iconColor='#000'
          
        />
      </FixedButton>
    </div>
  );
};

export default PayConfirmConsumer;
